import produce from 'immer';
import { uniqueId } from 'lodash';
import {
  setTabContentPorStatus,
  setTabContentPorStatusSingleObj,
} from '../../utils/setTabContentPorStatus';
import { TipoStatusEnum } from '../../enums';

// Action types
export const Types = {
  GET_CONTRATANTES_USUARIO_REQUEST: '@usuario/GET_CONTRATANTES_USUARIO_REQUEST',
  GET_CONTRATANTES_USUARIO_SUCCESS: '@usuario/GET_CONTRATANTES_USUARIO_SUCCESS',
  GET_CONTRATANTES_USUARIO_ERROR: '@usuario/GET_CONTRATANTES_USUARIO_ERROR',
  GET_PARAMETRIZACAO_USUARIO_REQUEST:
    '@usuario/GET_PARAMETRIZACAO_USUARIO_REQUEST',
  GET_PARAMETRIZACAO_USUARIO_SUCCESS:
    '@usuario/GET_PARAMETRIZACAO_USUARIO_SUCCESS',
  GET_PARAMETRIZACAO_USUARIO_ERROR: '@usuario/GET_PARAMETRIZACAO_USUARIO_ERROR',
  GET_CONSULTA_USUARIOS_REQUEST: '@usuario/GET_CONSULTA_USUARIOS_REQUEST',
  GET_CONSULTA_USUARIOS_SUCCESS: '@usuario/GET_CONSULTA_USUARIOS_SUCCESS',
  GET_CONSULTA_USUARIOS_ERROR: '@usuario/GET_CONSULTA_USUARIOS_ERROR',
  GET_CONSULTA_USUARIOS_POR_STATUS_REQUEST:
    '@usuario/GET_CONSULTA_USUARIOS_POR_STATUS_REQUEST',
  GET_CONSULTA_USUARIOS_POR_STATUS_SUCCESS:
    '@usuario/GET_CONSULTA_USUARIOS_POR_STATUS_SUCCESS',
  GET_CONSULTA_USUARIOS_POR_STATUS_ERROR:
    '@usuario/GET_CONSULTA_USUARIOS_POR_STATUS_ERROR',
  GET_USUARIO_BY_ID_REQUEST: '@usuario/GET_USUARIO_BY_ID_REQUEST',
  GET_USUARIO_BY_ID_SUCCESS: '@usuario/GET_USUARIO_BY_ID_SUCCESS',
  GET_USUARIO_BY_ID_ERROR: '@usuario/GET_USUARIO_BY_ID_ERROR',
  GET_CONTATO_BY_ID_REQUEST: '@usuario/GET_CONTATO_BY_ID_REQUEST',
  GET_CONTATO_BY_ID_SUCCESS: '@usuario/GET_CONTATO_BY_ID_SUCCESS',
  GET_CONTATO_BY_ID_ERROR: '@usuario/GET_CONTATO_BY_ID_ERROR',
  GET_DADOS_ACESSO_BY_ID_REQUEST: '@usuario/GET_DADOS_ACESSO_BY_ID_REQUEST',
  GET_DADOS_ACESSO_BY_ID_SUCCESS: '@usuario/GET_DADOS_ACESSO_BY_ID_SUCCESS',
  GET_DADOS_ACESSO_BY_ID_ERROR: '@usuario/GET_DADOS_ACESSO_BY_ID_ERROR',
  GET_HISTORICO_MOVIMENTACOES_REQUEST:
    '@usuario/GET_HISTORICO_MOVIMENTACOES_REQUEST',
  GET_HISTORICO_MOVIMENTACOES_SUCCESS:
    '@usuario/GET_HISTORICO_MOVIMENTACOES_SUCCESS',
  GET_HISTORICO_MOVIMENTACOES_ERROR:
    '@usuario/GET_HISTORICO_MOVIMENTACOES_ERROR',
  PATCH_LIBERAR_ACESSO_USUARIO_REQUEST:
    '@usuario/PATCH_LIBERAR_ACESSO_USUARIO_REQUEST',
  PATCH_LIBERAR_ACESSO_USUARIO_RENEW:
    '@usuario/PATCH_LIBERAR_ACESSO_USUARIO_RENEW',
  PATCH_LIBERAR_ACESSO_USUARIO_SUCCESS:
    '@usuario/PATCH_LIBERAR_ACESSO_USUARIO_SUCCESS',
  PATCH_LIBERAR_ACESSO_USUARIO_ERROR:
    '@usuario/PATCH_LIBERAR_ACESSO_USUARIO_ERROR',
  PATCH_STATUS_USUARIO_REQUEST: '@usuario/PATCH_STATUS_USUARIO_REQUEST',
  PATCH_STATUS_USUARIO_RENEW: '@usuario/PATCH_STATUS_USUARIO_RENEW',
  PATCH_STATUS_USUARIO_SUCCESS: '@usuario/PATCH_STATUS_USUARIO_SUCCESS',
  PATCH_STATUS_USUARIO_ERROR: '@usuario/PATCH_STATUS_USUARIO_ERROR',
  PATCH_REGISTRAR_CONTATO_USUARIO_REQUEST:
    '@usuario/PATCH_REGISTRAR_CONTATO_USUARIO_REQUEST',
  PATCH_REGISTRAR_CONTATO_USUARIO_RENEW:
    '@usuario/PATCH_REGISTRAR_CONTATO_USUARIO_RENEW',
  PATCH_REGISTRAR_CONTATO_USUARIO_SUCCESS:
    '@usuario/PATCH_REGISTRAR_CONTATO_USUARIO_SUCCESS',
  PATCH_REGISTRAR_CONTATO_USUARIO_ERROR:
    '@usuario/PATCH_REGISTRAR_CONTATO_USUARIO_ERROR',
  PATCH_SENHA_USUARIO_REQUEST: '@usuario/PATCH_SENHA_USUARIO_REQUEST',
  PATCH_SENHA_USUARIO_RENEW: '@usuario/PATCH_SENHA_USUARIO_RENEW',
  PATCH_SENHA_USUARIO_SUCCESS: '@usuario/PATCH_SENHA_USUARIO_SUCCESS',
  PATCH_SENHA_USUARIO_ERROR: '@usuario/PATCH_SENHA_USUARIO_ERROR',
  PATCH_DADOS_GERAIS_REQUEST: '@usuario/PATCH_DADOS_GERAIS_REQUEST',
  PATCH_DADOS_GERAIS_RENEW: '@usuario/PATCH_DADOS_GERAIS_RENEW',
  PATCH_DADOS_GERAIS_SUCCESS: '@usuario/PATCH_DADOS_GERAIS_SUCCESS',
  PATCH_DADOS_GERAIS_ERROR: '@usuario/PATCH_DADOS_GERAIS_ERROR',
  PATCH_DADOS_ACESSO_REQUEST: '@usuario/PATCH_DADOS_ACESSO_REQUEST',
  PATCH_DADOS_ACESSO_RENEW: '@usuario/PATCH_DADOS_ACESSO_RENEW',
  PATCH_DADOS_ACESSO_SUCCESS: '@usuario/PATCH_DADOS_ACESSO_SUCCESS',
  PATCH_DADOS_ACESSO_ERROR: '@usuario/PATCH_DADOS_ACESSO_ERROR',
  CRIAR_USUARIO_REQUEST: '@usuario/CRIAR_USUARIO_REQUEST',
  CRIAR_USUARIO_SUCCESS: '@usuario/CRIAR_USUARIO_SUCCESS',
  CRIAR_USUARIO_ERROR: '@usuario/CRIAR_USUARIO_ERROR',
  CRIAR_USUARIO_RENEW: '@usuario/CRIAR_USUARIO_RENEW',
  POST_PARAMETRIZACAO_CONTRATANTE_REQUEST:
    '@usuario/POST_PARAMETRIZACAO_CONTRATANTE_REQUEST',
  POST_PARAMETRIZACAO_CONTRATANTE_SUCCESS:
    '@usuario/POST_PARAMETRIZACAO_CONTRATANTE_SUCCESS',
  POST_PARAMETRIZACAO_CONTRATANTE_ERROR:
    '@usuario/POST_PARAMETRIZACAO_CONTRATANTE_ERROR',
  GET_PARAMETRIZACAO_CARDS_REQUEST: '@usuario/GET_PARAMETRIZACAO_CARDS_REQUEST',
  GET_PARAMETRIZACAO_CARDS_SUCCESS: '@usuario/GET_PARAMETRIZACAO_CARDS_SUCCESS',
  GET_PARAMETRIZACAO_CARDS_ERROR: '@usuario/GET_PARAMETRIZACAO_CARDS_ERROR',
  POST_PARAMETRIZACAO_USUARIO_REQUEST:
    '@usuario/POST_PARAMETRIZACAO_USUARIO_REQUEST',
  POST_PARAMETRIZACAO_USUARIO_SUCCESS:
    '@usuario/POST_PARAMETRIZACAO_USUARIO_SUCCESS',
  POST_PARAMETRIZACAO_USUARIO_ERROR:
    '@usuario/POST_PARAMETRIZACAO_USUARIO_ERROR',
  PUT_PARAMETRIZACAO_USUARIO_REQUEST:
    '@usuario/PUT_PARAMETRIZACAO_USUARIO_REQUEST',
  PUT_PARAMETRIZACAO_USUARIO_SUCCESS:
    '@usuario/PUT_PARAMETRIZACAO_USUARIO_SUCCESS',
  PUT_PARAMETRIZACAO_USUARIO_ERROR: '@usuario/PUT_PARAMETRIZACAO_USUARIO_ERROR',
  GET_PARAMETRIZACAO_NODE_REQUEST: '@usuario/GET_PARAMETRIZACAO_NODE_REQUEST',
  GET_PARAMETRIZACAO_NODE_SUCCESS: '@usuario/GET_PARAMETRIZACAO_NODE_SUCCESS',
  GET_PARAMETRIZACAO_NODE_ERROR: '@usuario/GET_PARAMETRIZACAO_NODE_ERROR',
  PARAMETRIZACAO_USUARIO_RENEW: '@usuario/PARAMETRIZACAO_USUARIO_RENEW',
  POST_ATUALIZAR_SESSAO_LEGADO_REQUEST:
    '@usuario/POST_ATUALIZAR_SESSAO_LEGADO_REQUEST',
  POST_ATUALIZAR_SESSAO_LEGADO_SUCCESS:
    '@usuario/POST_ATUALIZAR_SESSAO_LEGADO_SUCCESS',
  POST_ATUALIZAR_SESSAO_LEGADO_ERROR:
    '@usuario/POST_ATUALIZAR_SESSAO_LEGADO_ERROR',
  GET_PARAMETRIZACAO_CARD_COMPLETO_REQUEST:
    '@usuario/GET_PARAMETRIZACAO_CARD_COMPLETO_REQUEST',
  GET_PARAMETRIZACAO_CARD_COMPLETO_ERROR:
    '@usuario/GET_PARAMETRIZACAO_CARD_COMPLETO_ERROR',
  GET_PARAMETRIZACAO_CARD_COMPLETO_SUCCESS:
    '@usuario/GET_PARAMETRIZACAO_CARD_COMPLETO_SUCCESS',
  PATCH_PARAMETRIZACAO_INATIVAR_REQUEST:
    '@usuario/PATCH_PARAMETRIZACAO_INATIVAR_REQUEST',
  PATCH_PARAMETRIZACAO_ADM_INATIVAR_REQUEST:
    '@usuario/PATCH_PARAMETRIZACAO_ADM_INATIVAR_REQUEST',
  PATCH_PARAMETRIZACAO_INATIVAR_ERROR:
    '@usuario/PATCH_PARAMETRIZACAO_INATIVAR_ERROR',
  PATCH_PARAMETRIZACAO_INATIVAR_SUCCESS:
    '@usuario/PATCH_PARAMETRIZACAO_INATIVAR_SUCCESS',
  SAVE_PARAMETRIZACAO_CARDS_REQUEST:
    '@usuario/SAVE_PARAMETRIZACAO_CARDS_REQUEST',
  SAVE_PARAMETRIZACAO_CARDS_ERROR: '@usuario/SAVE_PARAMETRIZACAO_CARDS_ERROR',
  SAVE_PARAMETRIZACAO_CARDS_SUCCESS:
    '@usuario/SAVE_PARAMETRIZACAO_CARDS_SUCCESS',
  GET_AND_BUILD_PARAMETRIZACAO_CARDS_REQUEST:
    '@usuario/GET_AND_BUILD_PARAMETRIZACAO_CARDS_REQUEST',
  GET_AND_BUILD_PARAMETRIZACAO_CARDS_SUCCESS:
    '@usuario/GET_AND_BUILD_PARAMETRIZACAO_CARDS_SUCCESS',
  GET_AND_BUILD_PARAMETRIZACAO_CARDS_ERROR:
    '@usuario/GET_AND_BUILD_PARAMETRIZACAO_CARDS_ERROR',
  GET_USUARIOS_ESPELHO_REQUEST: '@usuario/GET_USUARIOS_ESPELHO_REQUEST',
  POST_CLONAR_USUARIO_ESPELHO_REQUEST:
    '@usuario/POST_CLONAR_USUARIO_ESPELHO_REQUEST',
  PATCH_ATUALIZAR_TIPO_PERFIL_REQUEST:
    '@usuario/PATCH_ATUALIZAR_TIPO_PERFIL_REQUEST',
  USUARIO_ESPELHO_SET: '@usuario/USUARIO_ESPELHO_SET',
  USUARIO_ESPELHO_RENEW: '@usuario/USUARIO_ESPELHO_RENEW',

  SUCCESS: '@usuario/SUCCESS',
  ERROR: '@usuario/ERROR',
  RENEW: '@usuario/RENEW',
};

const INITIAL_STATE = {
  loading: false,
  success: false,
  error: null,
  isError: false,
  responseUsuarioEspelho: {},
  usuarioEspelho: {},

  isPatchLiberarAcessoSuccess: false,
  isPatchInativarAtivarSuccess: false,
  isPatchRegistrarContato: false,
  isPatchSenha: false,
  unsucessResponse: '',
  newUsuario: {
    loading: false,
    success: false,
    response: [],
    unsuccessResponse: null,
    error: null,
    isError: false,
  },
  patchStatusUsuario: {
    loading: false,
    success: false,
    response: [],
    unsuccessResponse: null,
    error: null,
    isError: false,
  },
  patchLiberarAcesso: {
    loading: false,
    success: false,
    response: [],
    unsuccessResponse: null,
    error: null,
    isError: false,
  },
  getConsultaUsuarios: {
    loading: false,
    success: false,
    response: {
      Todas: { data: [], size: 0 },
      Ativo: { data: [], size: 0 },
      PendenteLiberacao: { data: [], size: 0 },
      Inativo: { data: [], size: 0 },
    },
    unsuccessResponse: [],
    error: null,
    isError: false,
  },
  getUsuarioById: {
    loading: false,
    success: false,
    response: [],
    unsuccessResponse: null,
    error: null,
    isError: false,
  },
  getContatoById: {
    loading: false,
    success: false,
    response: [],
    unsuccessResponse: null,
    error: null,
  },
  getDadosAcessoById: {
    loading: false,
    success: false,
    response: [],
    unsuccessResponse: null,
    error: null,
  },
  getHistoricoMovimentacoes: {
    loading: false,
    success: false,
    response: {
      data: [],
      size: 0,
    },
    unsuccessResponse: null,
    error: null,
  },
  getGrupoContratantes: {
    loading: false,
    success: false,
    response: {
      data: [],
      size: 0,
    },
    unsuccessResponse: null,
    error: null,
  },
  getContratantes: {
    loading: false,
    success: false,
    response: {
      data: [],
      size: 0,
    },
    unsuccessResponse: null,
    error: null,
  },
  patchDadosGerais: {
    loading: false,
    success: false,
    response: [],
    unsuccessResponse: null,
    error: null,
    isError: false,
  },
  patchRegistrarContato: {
    loading: false,
    success: false,
    unsuccessResponse: null,
    error: null,
    isError: false,
  },
  patchDadosAcesso: {
    loading: false,
    success: false,
    response: [],
    unsuccessResponse: null,
    error: null,
    isError: false,
  },
  patchSenha: {
    loading: false,
    success: false,
    isError: false,
    error: [],
  },
  postParametrizacaoContratante: {
    loading: false,
    success: false,
    response: [],
    unsuccessResponse: null,
    error: null,
    isError: false,
  },
  getParametrizacaoUsuario: {
    loading: false,
    success: false,
    response: [{}],
    unsuccessResponse: null,
    error: null,
    isError: false,
  },
  getContratantesUsuario: {
    loading: false,
    success: false,
    response: [],
    unsuccessResponse: null,
    error: null,
    isError: false,
  },
  getParametrizacaoCards: {
    loading: false,
    success: false,
    response: [],
    unsuccessResponse: null,
    error: null,
    isError: false,
  },
  postParametrizacaoUsuario: {
    loading: false,
    success: false,
    response: [],
    unsuccessResponse: null,
    error: null,
    isError: false,
    id: uniqueId('req_'),
  },
  getParametrizacaoNode: {
    loading: false,
    success: false,
    response: {},
    unsuccessResponse: null,
    error: null,
    isError: false,
  },
  putParametrizacaoUsuario: {
    loading: false,
    success: false,
    response: {},
    unsuccessResponse: null,
    error: null,
    isError: false,
    id: uniqueId('req_'),
  },
  postAtualizarSessaoLegado: {
    loading: false,
    success: false,
    response: {},
    unsuccessResponse: null,
    error: null,
    isError: false,
  },
  getParametrizacaoCardsCompleto: {
    loading: false,
    success: false,
    response: {},
    error: null,
    isError: false,
  },
  patchParametrizacaoInativar: {
    loading: false,
    success: false,
    error: null,
    isError: false,
  },
  saveParametrizacaoCards: {
    loading: false,
    success: false,
    error: null,
    isError: false,
    isSaveAll: false,
  },
  getAndBuildParametrizacaoCards: {
    loading: false,
    success: false,
    error: null,
    isError: false,
  },
};

export default function usuario(state = INITIAL_STATE, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case Types.GET_CONSULTA_USUARIOS_REQUEST: {
        draft.getConsultaUsuarios.loading = true;
        break;
      }
      case Types.GET_CONSULTA_USUARIOS_SUCCESS: {
        draft.getConsultaUsuarios.loading = false;
        setTabContentPorStatus(
          action.payload.response,
          TipoStatusEnum.returnTabForName,
          draft.getConsultaUsuarios.response
        );

        draft.getConsultaUsuarios.success = action.payload.success;
        break;
      }
      case Types.GET_CONSULTA_USUARIOS_ERROR: {
        draft.getConsultaUsuarios.loading = false;
        draft.getConsultaUsuarios.error = action.payload.error;
        break;
      }
      case Types.GET_CONSULTA_USUARIOS_POR_STATUS_REQUEST: {
        draft.getConsultaUsuarios.loading = true;
        break;
      }
      case Types.GET_CONSULTA_USUARIOS_POR_STATUS_SUCCESS: {
        draft.getConsultaUsuarios.loading = false;
        setTabContentPorStatusSingleObj(
          action.payload.response,
          TipoStatusEnum.returnTabForName,
          draft.getConsultaUsuarios.response
        );

        draft.getConsultaUsuarios.success = action.payload.success;
        break;
      }
      case Types.GET_CONSULTA_USUARIOS_POR_STATUS_ERROR: {
        draft.getConsultaUsuarios.loading = false;
        draft.getConsultaUsuarios.error = action.payload.error;
        break;
      }
      case Types.PATCH_LIBERAR_ACESSO_USUARIO_REQUEST: {
        draft.patchLiberarAcesso.success = false;
        draft.patchLiberarAcesso.isError = false;
        draft.patchLiberarAcesso.error = null;
        draft.patchLiberarAcesso.loading = false;
        draft.patchLiberarAcesso.unsuccessResponse = [];
        break;
      }
      case Types.PATCH_LIBERAR_ACESSO_USUARIO_RENEW: {
        draft.patchLiberarAcesso.success = false;
        draft.patchLiberarAcesso.isError = false;
        draft.patchLiberarAcesso.error = null;
        draft.patchLiberarAcesso.loading = false;
        draft.patchLiberarAcesso.unsuccessResponse = [];
        break;
      }
      case Types.PATCH_LIBERAR_ACESSO_USUARIO_SUCCESS: {
        draft.patchLiberarAcesso.success = action.payload.isSuccess;

        break;
      }
      case Types.PATCH_LIBERAR_ACESSO_USUARIO_ERROR: {
        draft.patchLiberarAcesso.error = action.payload.error;
        draft.patchLiberarAcesso.isError = true;
        draft.patchLiberarAcesso.unsuccessResponse =
          action.payload.unsuccessResponse;
        break;
      }
      case Types.GET_USUARIO_BY_ID_REQUEST: {
        draft.getUsuarioById.loading = true;
        draft.getUsuarioById.success = false;
        draft.getUsuarioById.error = null;
        draft.getUsuarioById.unsuccessResponse = null;
        break;
      }
      case Types.GET_USUARIO_BY_ID_SUCCESS: {
        draft.getUsuarioById.loading = false;
        draft.getUsuarioById.success = action.payload.isSuccess;
        draft.getUsuarioById.response = action.payload.usuarioById;
        break;
      }
      case Types.GET_USUARIO_BY_ID_ERROR: {
        draft.getUsuarioById.loading = false;
        draft.getUsuarioById.error = action.payload.error;
        draft.getUsuarioById.unsuccessResponse =
          action.payload.unsuccessResponse;
        break;
      }
      case Types.PATCH_STATUS_USUARIO_REQUEST: {
        draft.patchStatusUsuario.success = false;
        draft.patchStatusUsuario.unsuccessResponse = [];
        draft.patchStatusUsuario.loading = false;
        draft.patchStatusUsuario.isError = false;
        draft.patchStatusUsuario.error = [];
        break;
      }
      case Types.PATCH_STATUS_USUARIO_RENEW: {
        draft.patchStatusUsuario.success = false;
        draft.patchStatusUsuario.unsuccessResponse = [];
        draft.patchStatusUsuario.loading = false;
        draft.patchStatusUsuario.isError = false;
        draft.patchStatusUsuario.error = [];
        break;
      }
      case Types.PATCH_STATUS_USUARIO_SUCCESS: {
        draft.patchStatusUsuario.success = action.payload.isSuccess;
        draft.patchStatusUsuario.unsuccessResponse =
          action.payload.unsuccessResponse;
        break;
      }
      case Types.PATCH_STATUS_USUARIO_ERROR: {
        draft.patchStatusUsuario.error = action.payload.error;
        draft.patchStatusUsuario.isError = true;
        draft.patchStatusUsuario.unsuccessResponse =
          action.payload.unsuccessResponse;
        break;
      }
      case Types.CRIAR_USUARIO_REQUEST: {
        draft.newUsuario.loading = true;
        draft.newUsuario.success = false;
        draft.newUsuario.error = null;
        draft.newUsuario.unsuccessResponse = null;
        draft.newUsuario.isError = false;
        break;
      }
      case Types.CRIAR_USUARIO_SUCCESS: {
        draft.newUsuario.loading = false;
        draft.newUsuario.success = action.payload.isSuccess;
        draft.newUsuario.response = action.payload.newUsuario;
        draft.newUsuario.isError = false;

        break;
      }
      case Types.CRIAR_USUARIO_ERROR: {
        draft.newUsuario.loading = false;
        draft.newUsuario.error = action.payload.error;
        draft.newUsuario.unsuccessResponse = action.payload.unsuccessResponse;
        draft.newUsuario.isError = true;
        draft.newUsuario.success = false;
        break;
      }
      case Types.CRIAR_USUARIO_RENEW: {
        draft.newUsuario.success = false;
        draft.newUsuario.isError = false;
        draft.newUsuario.error = null;
        draft.newUsuario.loading = false;
        draft.newUsuario.unsuccessResponse = null;
        break;
      }
      case Types.PATCH_REGISTRAR_CONTATO_USUARIO_REQUEST: {
        draft.patchRegistrarContato.loading = true;
        draft.patchRegistrarContato.success = false;
        draft.patchRegistrarContato.isError = false;
        draft.patchRegistrarContato.error = null;
        draft.patchRegistrarContato.unsuccessResponse = [];
        break;
      }
      case Types.PATCH_REGISTRAR_CONTATO_USUARIO_RENEW: {
        draft.patchRegistrarContato.loading = false;
        draft.patchRegistrarContato.success = false;
        draft.patchRegistrarContato.isError = false;
        draft.patchRegistrarContato.error = null;
        draft.patchRegistrarContato.unsuccessResponse = [];
        break;
      }
      case Types.PATCH_REGISTRAR_CONTATO_USUARIO_SUCCESS: {
        draft.patchRegistrarContato.loading = false;
        draft.patchRegistrarContato.success = action.payload.isSuccess;
        draft.patchRegistrarContato.unsuccessResponse =
          action.payload.unsuccessResponse;
        break;
      }
      case Types.PATCH_REGISTRAR_CONTATO_USUARIO_ERROR: {
        draft.patchRegistrarContato.loading = false;
        draft.patchRegistrarContato.error = action.payload.error;
        draft.patchRegistrarContato.isError = true;
        break;
      }
      case Types.GET_CONTATO_BY_ID_REQUEST: {
        draft.getContatoById.loading = true;
        draft.getContatoById.success = false;
        draft.getContatoById.error = null;
        draft.getContatoById.unsuccessResponse = null;
        break;
      }
      case Types.GET_CONTATO_BY_ID_SUCCESS: {
        draft.getContatoById.loading = false;
        draft.getContatoById.success = action.payload.isSuccess;
        draft.getContatoById.response = action.payload.contatoById;
        break;
      }
      case Types.GET_CONTATO_BY_ID_ERROR: {
        draft.getContatoById.loading = false;
        draft.getContatoById.error = action.payload.error;
        draft.getContatoById.unsuccessResponse =
          action.payload.unsuccessResponse;
        break;
      }
      case Types.PATCH_SENHA_USUARIO_REQUEST: {
        draft.patchSenha.success = false;
        draft.patchSenha.isError = false;
        draft.patchSenha.loading = true;
        draft.patchSenha.error = [];
        break;
      }
      case Types.PATCH_SENHA_USUARIO_RENEW: {
        draft.patchSenha.success = false;
        draft.patchSenha.isError = false;
        draft.patchSenha.loading = true;
        break;
      }
      case Types.PATCH_SENHA_USUARIO_SUCCESS: {
        draft.patchSenha.success = true;
        draft.patchSenha.loading = false;
        break;
      }
      case Types.PATCH_SENHA_USUARIO_ERROR: {
        draft.error = action.payload.error;
        draft.patchSenha.isError = true;
        draft.patchSenha.error = action.payload.error;
        draft.patchSenha.loading = false;
        break;
      }
      case Types.GET_DADOS_ACESSO_BY_ID_REQUEST: {
        draft.getDadosAcessoById.loading = true;
        draft.getDadosAcessoById.success = false;
        draft.getDadosAcessoById.error = null;
        draft.getDadosAcessoById.unsuccessResponse = null;
        break;
      }
      case Types.GET_DADOS_ACESSO_BY_ID_SUCCESS: {
        draft.getDadosAcessoById.loading = false;
        draft.getDadosAcessoById.success = action.payload.isSuccess;
        draft.getDadosAcessoById.response = action.payload.usuarioById;
        break;
      }
      case Types.GET_DADOS_ACESSO_BY_ID_ERROR: {
        draft.getDadosAcessoById.loading = false;
        draft.getDadosAcessoById.error = action.payload.error;
        draft.getDadosAcessoById.unsuccessResponse =
          action.payload.unsuccessResponse;
        break;
      }
      case Types.PATCH_DADOS_GERAIS_REQUEST: {
        draft.patchDadosGerais.loading = true;
        draft.patchDadosGerais.success = false;
        draft.patchDadosGerais.isError = false;
        draft.patchDadosGerais.error = null;
        draft.patchDadosGerais.unsuccessResponse = null;
        break;
      }
      case Types.PATCH_DADOS_GERAIS_RENEW: {
        draft.patchDadosGerais.loading = false;
        draft.patchDadosGerais.success = false;
        draft.patchDadosGerais.isError = false;
        draft.patchDadosGerais.error = null;
        draft.patchDadosGerais.unsuccessResponse = null;
        break;
      }
      case Types.PATCH_DADOS_GERAIS_SUCCESS: {
        draft.patchDadosGerais.loading = false;
        draft.patchDadosGerais.isError = false;
        draft.patchDadosGerais.success = action.payload.isSuccess;
        draft.patchDadosGerais.response = action.payload.response;
        break;
      }
      case Types.PATCH_DADOS_GERAIS_ERROR: {
        draft.patchDadosGerais.loading = false;
        draft.patchDadosGerais.isError = true;
        draft.patchDadosGerais.error = action.payload.error;
        draft.patchDadosGerais.unsuccessResponse =
          action.payload.unsuccessResponse;
        break;
      }
      case Types.PATCH_DADOS_ACESSO_REQUEST: {
        draft.patchDadosAcesso.loading = true;
        draft.patchDadosAcesso.success = false;
        draft.patchDadosAcesso.isError = false;
        draft.patchDadosAcesso.error = null;
        draft.patchDadosAcesso.unsuccessResponse = null;
        break;
      }
      case Types.PATCH_DADOS_ACESSO_RENEW: {
        draft.patchDadosAcesso.loading = false;
        draft.patchDadosAcesso.success = false;
        draft.patchDadosAcesso.isError = false;
        draft.patchDadosAcesso.error = null;
        draft.patchDadosAcesso.unsuccessResponse = null;
        break;
      }
      case Types.PATCH_DADOS_ACESSO_SUCCESS: {
        draft.patchDadosAcesso.loading = false;
        draft.patchDadosAcesso.isError = false;
        draft.patchDadosAcesso.success = true;
        draft.patchDadosAcesso.response = action.payload.response;
        break;
      }
      case Types.PATCH_DADOS_ACESSO_ERROR: {
        draft.patchDadosAcesso.loading = false;
        draft.patchDadosAcesso.isError = true;
        draft.patchDadosAcesso.error = action.payload.error;
        draft.patchDadosAcesso.unsuccessResponse =
          action.payload.unsuccessResponse;
        break;
      }
      case Types.GET_HISTORICO_MOVIMENTACOES_REQUEST: {
        draft.getHistoricoMovimentacoes.loading = true;
        draft.getHistoricoMovimentacoes.success = false;
        draft.getHistoricoMovimentacoes.error = null;
        draft.getHistoricoMovimentacoes.unsuccessResponse = null;
        break;
      }
      case Types.GET_HISTORICO_MOVIMENTACOES_SUCCESS: {
        draft.getHistoricoMovimentacoes.loading = false;
        draft.getHistoricoMovimentacoes.success = action.payload.isSuccess;
        draft.getHistoricoMovimentacoes.response.data =
          action.payload.historicoMovimentacao;
        draft.getHistoricoMovimentacoes.response.size =
          action.payload.historicoMovimentacao.total;
        break;
      }
      case Types.GET_HISTORICO_MOVIMENTACOES_ERROR: {
        draft.getHistoricoMovimentacoes.loading = false;
        draft.getHistoricoMovimentacoes.error = action.payload.error;
        draft.getHistoricoMovimentacoes.unsuccessResponse =
          action.payload.unsuccessResponse;
        break;
      }
      case Types.POST_PARAMETRIZACAO_CONTRATANTE_REQUEST: {
        draft.postParametrizacaoContratante.loading = true;
        draft.postParametrizacaoContratante.success = false;
        draft.postParametrizacaoContratante.error = null;
        draft.postParametrizacaoContratante.isError = null;
        draft.postParametrizacaoContratante.unsuccessResponse = null;
        break;
      }
      case Types.POST_PARAMETRIZACAO_CONTRATANTE_SUCCESS: {
        draft.postParametrizacaoContratante.loading = false;
        draft.postParametrizacaoContratante.success = action.payload.isSuccess;
        draft.postParametrizacaoContratante.response = action.payload.response;
        draft.postParametrizacaoContratante.isError = false;
        break;
      }
      case Types.POST_PARAMETRIZACAO_CONTRATANTE_ERROR: {
        draft.patchDadosAcesso.loading = false;
        draft.patchDadosAcesso.isError = true;
        draft.patchDadosAcesso.error = action.payload.error;
        draft.patchDadosAcesso.unsuccessResponse =
          action.payload.unsuccessResponse;
        break;
      }
      case Types.GET_PARAMETRIZACAO_USUARIO_REQUEST: {
        draft.getParametrizacaoUsuario.loading = true;
        draft.getParametrizacaoUsuario.success = false;
        draft.getParametrizacaoUsuario.error = null;
        draft.getParametrizacaoUsuario.isError = null;
        draft.getParametrizacaoUsuario.unsuccessResponse = null;
        break;
      }
      case Types.GET_PARAMETRIZACAO_USUARIO_SUCCESS: {
        draft.getParametrizacaoUsuario.loading = false;
        draft.getParametrizacaoUsuario.success = action.payload.isSuccess;
        draft.getParametrizacaoUsuario.response = action.payload.response;
        draft.getParametrizacaoUsuario.isError = false;
        break;
      }
      case Types.GET_PARAMETRIZACAO_USUARIO_ERROR: {
        draft.getContratantesUsuario.loading = false;
        draft.getContratantesUsuario.isError = true;
        draft.getContratantesUsuario.error = action.payload.error;
        draft.getContratantesUsuario.unsuccessResponse =
          action.payload.unsuccessResponse;
        break;
      }
      case Types.GET_CONTRATANTES_USUARIO_REQUEST: {
        draft.getContratantesUsuario.loading = true;
        draft.getContratantesUsuario.success = false;
        draft.getContratantesUsuario.error = null;
        draft.getContratantesUsuario.isError = null;
        draft.getContratantesUsuario.unsuccessResponse = null;
        break;
      }
      case Types.GET_CONTRATANTES_USUARIO_SUCCESS: {
        draft.getContratantesUsuario.loading = false;
        draft.getContratantesUsuario.success = action.payload.isSuccess;
        draft.getContratantesUsuario.response = action.payload.response;
        draft.getContratantesUsuario.isError = false;
        break;
      }
      case Types.GET_CONTRATANTES_USUARIO_ERROR: {
        draft.getContratantesUsuario.loading = false;
        draft.getContratantesUsuario.isError = true;
        draft.getContratantesUsuario.error = action.payload.error;
        draft.getContratantesUsuario.unsuccessResponse =
          action.payload.unsuccessResponse;
        break;
      }
      case Types.GET_PARAMETRIZACAO_CARDS_REQUEST: {
        draft.getParametrizacaoCards.loading = true;
        draft.getParametrizacaoCards.success = false;
        draft.getParametrizacaoCards.error = null;
        draft.getParametrizacaoCards.isError = null;
        draft.getParametrizacaoCards.unsuccessResponse = null;
        break;
      }
      case Types.GET_PARAMETRIZACAO_CARDS_SUCCESS: {
        draft.getParametrizacaoCards.loading = false;
        draft.getParametrizacaoCards.success = action.payload.isSuccess;
        draft.getParametrizacaoCards.response = action.payload.response;
        draft.getParametrizacaoCards.isError = false;
        break;
      }
      case Types.GET_PARAMETRIZACAO_CARDS_ERROR: {
        draft.getParametrizacaoCards.loading = false;
        draft.getParametrizacaoCards.isError = true;
        draft.getParametrizacaoCards.error = action.payload.error;
        draft.getParametrizacaoCards.unsuccessResponse =
          action.payload.unsuccessResponse;
        break;
      }
      case Types.POST_PARAMETRIZACAO_USUARIO_REQUEST: {
        draft.postParametrizacaoUsuario.loading = true;
        draft.postParametrizacaoUsuario.success = false;
        draft.postParametrizacaoUsuario.error = null;
        draft.postParametrizacaoUsuario.isError = null;
        draft.postParametrizacaoUsuario.unsuccessResponse = null;
        break;
      }
      case Types.POST_PARAMETRIZACAO_USUARIO_SUCCESS: {
        draft.postParametrizacaoUsuario.loading = false;
        draft.postParametrizacaoUsuario.success = action.payload.isSuccess;
        draft.postParametrizacaoUsuario.response = action.payload.response;
        draft.postParametrizacaoUsuario.hasValidationErros =
          action.payload.hasValidationErros;
        draft.postParametrizacaoUsuario.error = action.payload.errors;
        draft.postParametrizacaoUsuario.isError = false;
        break;
      }
      case Types.POST_PARAMETRIZACAO_USUARIO_ERROR: {
        draft.postParametrizacaoUsuario.loading = false;
        draft.postParametrizacaoUsuario.isError = true;
        draft.postParametrizacaoUsuario.error = action.payload.error;
        draft.postParametrizacaoUsuario.unsuccessResponse =
          action.payload.unsuccessResponse;
        break;
      }
      case Types.GET_PARAMETRIZACAO_NODE_REQUEST: {
        draft.getParametrizacaoNode.loading = true;
        draft.getParametrizacaoNode.success = false;
        draft.getParametrizacaoNode.error = null;
        draft.getParametrizacaoNode.isError = null;
        draft.getParametrizacaoNode.unsuccessResponse = null;
        break;
      }
      case Types.GET_PARAMETRIZACAO_NODE_SUCCESS: {
        draft.getParametrizacaoNode.loading = false;
        draft.getParametrizacaoNode.success = action.payload.isSuccess;
        draft.getParametrizacaoNode.response = action.payload.response;
        draft.getParametrizacaoNode.isError = false;
        break;
      }
      case Types.GET_PARAMETRIZACAO_NODE_ERROR: {
        draft.getParametrizacaoNode.loading = false;
        draft.getParametrizacaoNode.isError = true;
        draft.getParametrizacaoNode.error = action.payload.error;
        draft.getParametrizacaoNode.unsuccessResponse =
          action.payload.unsuccessResponse;
        break;
      }
      case Types.PUT_PARAMETRIZACAO_USUARIO_REQUEST: {
        draft.putParametrizacaoUsuario.loading = true;
        draft.putParametrizacaoUsuario.success = false;
        draft.putParametrizacaoUsuario.error = null;
        draft.putParametrizacaoUsuario.isError = null;
        draft.putParametrizacaoUsuario.unsuccessResponse = null;
        break;
      }
      case Types.PUT_PARAMETRIZACAO_USUARIO_SUCCESS: {
        draft.putParametrizacaoUsuario.loading = false;
        draft.putParametrizacaoUsuario.success = action.payload.isSuccess;
        draft.putParametrizacaoUsuario.response = action.payload.response;
        draft.putParametrizacaoUsuario.isError = false;
        draft.putParametrizacaoUsuario.hasValidationErros =
          action.payload.hasValidationErros;
        draft.putParametrizacaoUsuario.error = action.payload.errors;
        break;
      }
      case Types.PUT_PARAMETRIZACAO_USUARIO_ERROR: {
        draft.putParametrizacaoUsuario.loading = false;
        draft.putParametrizacaoUsuario.isError = true;
        draft.putParametrizacaoUsuario.error = action.payload.error;
        draft.putParametrizacaoUsuario.unsuccessResponse =
          action.payload.unsuccessResponse;
        break;
      }
      case Types.PARAMETRIZACAO_USUARIO_RENEW: {
        draft.putParametrizacaoUsuario.loading = false;
        draft.putParametrizacaoUsuario.success = false;
        draft.putParametrizacaoUsuario.error = null;
        draft.putParametrizacaoUsuario.isError = null;
        draft.putParametrizacaoUsuario.unsuccessResponse = null;
        draft.postParametrizacaoUsuario.loading = false;
        draft.postParametrizacaoUsuario.success = false;
        draft.postParametrizacaoUsuario.error = null;
        draft.postParametrizacaoUsuario.isError = null;
        draft.postParametrizacaoUsuario.unsuccessResponse = null;
        draft.postParametrizacaoUsuario.hasValidationErros = false;
        draft.saveParametrizacaoCards.loading = false;
        draft.saveParametrizacaoCards.isSaveAll = false;
        draft.saveParametrizacaoCards.success = false;
        draft.saveParametrizacaoCards.error = null;
        draft.saveParametrizacaoCards.isError = null;
        draft.saveParametrizacaoCards.unsuccessResponse = null;
        draft.saveParametrizacaoCards.hasValidationErros = false;
        break;
      }
      case Types.POST_ATUALIZAR_SESSAO_LEGADO_REQUEST: {
        draft.postAtualizarSessaoLegado.loading = true;
        draft.postAtualizarSessaoLegado.success = false;
        draft.postAtualizarSessaoLegado.error = null;
        draft.postAtualizarSessaoLegado.isError = null;
        draft.postAtualizarSessaoLegado.unsuccessResponse = null;
        break;
      }
      case Types.POST_ATUALIZAR_SESSAO_LEGADO_SUCCESS: {
        draft.postAtualizarSessaoLegado.loading = false;
        draft.postAtualizarSessaoLegado.success = action.payload.isSuccess;
        draft.postAtualizarSessaoLegado.response = action.payload.response;
        draft.postAtualizarSessaoLegado.isError = false;
        break;
      }
      case Types.POST_ATUALIZAR_SESSAO_LEGADO_ERROR: {
        draft.postAtualizarSessaoLegado.loading = false;
        draft.postAtualizarSessaoLegado.isError = true;
        draft.postAtualizarSessaoLegado.error = action.payload.error;
        draft.postAtualizarSessaoLegado.unsuccessResponse =
          action.payload.unsuccessResponse;
        break;
      }
      case Types.GET_PARAMETRIZACAO_CARD_COMPLETO_REQUEST: {
        draft.getParametrizacaoCardsCompleto.loading = true;
        draft.getParametrizacaoCardsCompleto.success = false;
        draft.getParametrizacaoCardsCompleto.error = null;
        draft.getParametrizacaoCardsCompleto.isError = null;
        break;
      }
      case Types.GET_PARAMETRIZACAO_CARD_COMPLETO_SUCCESS: {
        draft.getParametrizacaoCardsCompleto.loading = false;
        draft.getParametrizacaoCardsCompleto.success = action.payload.isSuccess;
        draft.getParametrizacaoCardsCompleto.response = action.payload.response;
        draft.getParametrizacaoCardsCompleto.isError = false;
        break;
      }
      case Types.GET_PARAMETRIZACAO_CARD_COMPLETO_ERROR: {
        draft.getParametrizacaoCardsCompleto.loading = false;
        draft.getParametrizacaoCardsCompleto.isError = true;
        draft.getParametrizacaoCardsCompleto.error = action.payload.error;

        break;
      }
      case Types.PATCH_PARAMETRIZACAO_INATIVAR_REQUEST: {
        draft.patchParametrizacaoInativar.loading = true;
        draft.patchParametrizacaoInativar.success = false;
        draft.patchParametrizacaoInativar.error = null;
        draft.patchParametrizacaoInativar.isError = null;
        break;
      }
      case Types.PATCH_PARAMETRIZACAO_INATIVAR_SUCCESS: {
        draft.patchParametrizacaoInativar.loading = false;
        draft.patchParametrizacaoInativar.success = action.payload.isSuccess;
        draft.patchParametrizacaoInativar.isError = false;
        break;
      }
      case Types.PATCH_PARAMETRIZACAO_INATIVAR_ERROR: {
        draft.patchParametrizacaoInativar.loading = false;
        draft.patchParametrizacaoInativar.isError = true;
        draft.patchParametrizacaoInativar.error = action.payload.error;

        break;
      }
      case Types.SAVE_PARAMETRIZACAO_CARDS_REQUEST: {
        draft.saveParametrizacaoCards.loading = true;
        draft.saveParametrizacaoCards.isSaveAll = action.payload.isSaveAll;
        draft.saveParametrizacaoCards.success = false;
        draft.saveParametrizacaoCards.error = null;
        draft.saveParametrizacaoCards.isError = null;
        break;
      }
      case Types.SAVE_PARAMETRIZACAO_CARDS_SUCCESS: {
        draft.saveParametrizacaoCards.loading = false;
        draft.saveParametrizacaoCards.success = action.payload.isSuccess;
        draft.saveParametrizacaoCards.response = action.payload.response;
        draft.saveParametrizacaoCards.isError = false;
        draft.saveParametrizacaoCards.hasValidationErrors =
          action.payload.hasValidationErrors;
        draft.saveParametrizacaoCards.error = action.payload.errors;
        break;
      }
      case Types.SAVE_PARAMETRIZACAO_CARDS_ERROR: {
        draft.saveParametrizacaoCards.loading = false;
        draft.saveParametrizacaoCards.isError = true;
        draft.saveParametrizacaoCards.error = action.payload.error;
        draft.saveParametrizacaoCards.isSaveAll = false;
        break;
      }
      case Types.GET_AND_BUILD_PARAMETRIZACAO_CARDS_REQUEST: {
        draft.getAndBuildParametrizacaoCards.loading = true;
        draft.getAndBuildParametrizacaoCards.success = false;
        draft.getAndBuildParametrizacaoCards.error = null;
        draft.getAndBuildParametrizacaoCards.isError = null;
        break;
      }
      case Types.GET_AND_BUILD_PARAMETRIZACAO_CARDS_SUCCESS: {
        draft.getAndBuildParametrizacaoCards.loading = false;
        draft.getAndBuildParametrizacaoCards.success = action.payload.isSuccess;
        draft.getAndBuildParametrizacaoCards.response = action.payload.response;
        draft.getAndBuildParametrizacaoCards.isError = false;
        draft.getAndBuildParametrizacaoCards.hasValidationErrors =
          action.payload.hasValidationErrors;
        draft.getAndBuildParametrizacaoCards.error = action.payload.errors;
        break;
      }
      case Types.GET_AND_BUILD_PARAMETRIZACAO_CARDS_ERROR: {
        draft.getAndBuildParametrizacaoCards.loading = false;
        draft.getAndBuildParametrizacaoCards.isError = true;
        draft.getAndBuildParametrizacaoCards.error = action.payload.error;
        break;
      }
      case (Types.RENEW, Types.GET_USUARIOS_ESPELHO_REQUEST): {
        draft.loading = true;
        draft.success = false;
        draft.error = null;
        draft.isError = false;
        draft.responseUsuarioEspelho = {};
        break;
      }
      case Types.USUARIO_ESPELHO_SET: {
        draft.usuarioEspelho = action.payload.usuarioEspelho;
        break;
      }
      case Types.USUARIO_ESPELHO_RENEW: {
        draft.usuarioEspelho = {};
        break;
      }

      case Types.SUCCESS: {
        draft.loading = false;
        draft.success = true;
        draft.error = null;
        draft.isError = false;
        draft.responseUsuarioEspelho = action.payload.response;
        break;
      }
      case Types.ERROR: {
        draft.loading = false;
        draft.success = false;
        draft.error = action.payload.error;
        draft.isError = true;
        draft.responseUsuarioEspelho = {};
        break;
      }
      default:
    }
  });
}

export const Creators = {
  getConsultaUsuariosRequest: (params, TipoStatus) => ({
    type: Types.GET_CONSULTA_USUARIOS_REQUEST,
    payload: { params, TipoStatus },
  }),
  getConsultaUsuariosSuccess: (response, success) => ({
    type: Types.GET_CONSULTA_USUARIOS_SUCCESS,
    payload: { response, success },
  }),
  getConsultaUsuariosError: (error) => ({
    type: Types.GET_CONSULTA_USUARIOS_ERROR,
    payload: { error },
  }),
  getConsultaUsuariosPorStatusRequest: (params) => ({
    type: Types.GET_CONSULTA_USUARIOS_POR_STATUS_REQUEST,
    payload: { params },
  }),
  getConsultaUsuariosPorStatusSuccess: (response, success) => ({
    type: Types.GET_CONSULTA_USUARIOS_POR_STATUS_SUCCESS,
    payload: { response, success },
  }),
  getConsultaUsuariosPorStatusError: (error) => ({
    type: Types.GET_CONSULTA_USUARIOS_POR_STATUS_ERROR,
    payload: { error },
  }),
  patchLiberarAcessoRequest: (usuarios) => ({
    type: Types.PATCH_LIBERAR_ACESSO_USUARIO_REQUEST,
    payload: { usuarios },
  }),
  patchLiberarAcessoRenew: () => ({
    type: Types.PATCH_LIBERAR_ACESSO_USUARIO_RENEW,
  }),
  patchLiberarAcessoSuccess: (unsuccessResponse, isSuccess) => ({
    type: Types.PATCH_LIBERAR_ACESSO_USUARIO_SUCCESS,
    payload: { unsuccessResponse, isSuccess },
  }),
  patchLiberarAcessoError: (error) => ({
    type: Types.PATCH_LIBERAR_ACESSO_USUARIO_ERROR,
    payload: { error },
  }),
  getUsuarioByIdRequest: (idUsuario) => ({
    type: Types.GET_USUARIO_BY_ID_REQUEST,
    payload: { idUsuario },
  }),
  getUsuarioByIdSuccess: (usuarioById, isSuccess) => ({
    type: Types.GET_USUARIO_BY_ID_SUCCESS,
    payload: { usuarioById, isSuccess },
  }),
  getUsuarioByIdError: (unsuccessResponse, error) => ({
    type: Types.GET_USUARIO_BY_ID_ERROR,
    payload: { unsuccessResponse, error },
  }),
  patchStatusRequest: (usuarios, tipoStatus) => ({
    type: Types.PATCH_STATUS_USUARIO_REQUEST,
    payload: { usuarios, tipoStatus },
  }),
  patchStatusRenew: () => ({
    type: Types.PATCH_STATUS_USUARIO_RENEW,
  }),
  patchStatusSuccess: (unsuccessResponse, isSuccess) => ({
    type: Types.PATCH_STATUS_USUARIO_SUCCESS,
    payload: { unsuccessResponse, isSuccess },
  }),
  patchStatusError: (error) => ({
    type: Types.PATCH_STATUS_USUARIO_ERROR,
    payload: { error },
  }),
  criarUsuarioRequest: (data) => ({
    type: Types.CRIAR_USUARIO_REQUEST,
    payload: { data },
  }),
  criarUsuarioSuccess: (newUsuario, isSuccess) => ({
    type: Types.CRIAR_USUARIO_SUCCESS,
    payload: { newUsuario, isSuccess },
  }),
  criarUsuarioError: (unsuccessResponse, error) => ({
    type: Types.CRIAR_USUARIO_ERROR,
    payload: { unsuccessResponse, error },
  }),
  criarUsuarioRenew: () => ({
    type: Types.CRIAR_USUARIO_RENEW,
  }),
  patchRegistrarContatoRequest: (contatos, idUsuario) => ({
    type: Types.PATCH_REGISTRAR_CONTATO_USUARIO_REQUEST,
    payload: { contatos, idUsuario },
  }),
  patchRegistrarContatoRenew: () => ({
    type: Types.PATCH_REGISTRAR_CONTATO_USUARIO_RENEW,
  }),
  patchRegistrarContatoSuccess: (unsuccessResponse, isSuccess) => ({
    type: Types.PATCH_REGISTRAR_CONTATO_USUARIO_SUCCESS,
    payload: { unsuccessResponse, isSuccess },
  }),
  patchRegistrarContatoError: (error) => ({
    type: Types.PATCH_REGISTRAR_CONTATO_USUARIO_ERROR,
    payload: { error },
  }),
  getContatoByIdRequest: (idUsuario) => ({
    type: Types.GET_CONTATO_BY_ID_REQUEST,
    payload: { idUsuario },
  }),
  getContatoByIdSuccess: (contatoById, isSuccess) => ({
    type: Types.GET_CONTATO_BY_ID_SUCCESS,
    payload: { contatoById, isSuccess },
  }),
  getContatoByIdError: (unsuccessResponse, error) => ({
    type: Types.GET_CONTATO_BY_ID_ERROR,
    payload: { unsuccessResponse, error },
  }),
  patchSenhaRequest: (idUsuario, senha, novaSenha, confirmacaoSenha) => ({
    type: Types.PATCH_SENHA_USUARIO_REQUEST,
    payload: {
      idUsuario,
      senha,
      novaSenha,
      confirmacaoSenha,
    },
  }),
  patchSenhaRenew: () => ({
    type: Types.PATCH_SENHA_USUARIO_RENEW,
  }),
  patchSenhaSuccess: (unsuccessResponse, isSuccess) => ({
    type: Types.PATCH_SENHA_USUARIO_SUCCESS,
    payload: { unsuccessResponse, isSuccess },
  }),
  patchSenhaError: (error) => ({
    type: Types.PATCH_SENHA_USUARIO_ERROR,
    payload: { error },
  }),
  getDadosAcessoByIdRequest: (idUsuario) => ({
    type: Types.GET_DADOS_ACESSO_BY_ID_REQUEST,
    payload: { idUsuario },
  }),
  getDadosAcessoByIdSuccess: (usuarioById, isSuccess) => ({
    type: Types.GET_DADOS_ACESSO_BY_ID_SUCCESS,
    payload: { usuarioById, isSuccess },
  }),
  getDadosAcessoByIdError: (unsuccessResponse, error) => ({
    type: Types.GET_DADOS_ACESSO_BY_ID_ERROR,
    payload: { unsuccessResponse, error },
  }),
  patchDadosGeraisRequest: (params, contatos) => ({
    type: Types.PATCH_DADOS_GERAIS_REQUEST,
    payload: { params, contatos },
  }),
  patchDadosGeraisRenew: () => ({
    type: Types.PATCH_DADOS_GERAIS_RENEW,
  }),
  patchDadosGeraisSuccess: (response, isSuccess) => ({
    type: Types.PATCH_DADOS_GERAIS_SUCCESS,
    payload: { response, isSuccess },
  }),
  patchDadosGeraisError: (unsuccessResponse, error) => ({
    type: Types.PATCH_DADOS_GERAIS_ERROR,
    payload: { unsuccessResponse, error },
  }),
  patchDadosAcessoRequest: (params) => ({
    type: Types.PATCH_DADOS_ACESSO_REQUEST,
    payload: { params },
  }),
  patchDadosAcessoRenew: () => ({
    type: Types.PATCH_DADOS_ACESSO_RENEW,
  }),
  patchDadosAcessoSuccess: (response, isSuccess) => ({
    type: Types.PATCH_DADOS_ACESSO_SUCCESS,
    payload: { response, isSuccess },
  }),
  patchDadosAcessoError: (unsuccessResponse, error) => ({
    type: Types.PATCH_DADOS_ACESSO_ERROR,
    payload: { unsuccessResponse, error },
  }),
  getHistoricoMovimentacoesRequest: (idUsuario, params) => ({
    type: Types.GET_HISTORICO_MOVIMENTACOES_REQUEST,
    payload: { idUsuario, params },
  }),
  getHistoricoMovimentacoesSuccess: (historicoMovimentacao, isSuccess) => ({
    type: Types.GET_HISTORICO_MOVIMENTACOES_SUCCESS,
    payload: { historicoMovimentacao, isSuccess },
  }),
  getHistoricoMovimentacoesError: (unsuccessResponse, error) => ({
    type: Types.GET_HISTORICO_MOVIMENTACOES_ERROR,
    payload: { unsuccessResponse, error },
  }),
  postParametrizacaoContratanteRequest: (contratantes) => ({
    type: Types.POST_PARAMETRIZACAO_CONTRATANTE_REQUEST,
    payload: { contratantes },
  }),
  postParametrizacaoContratanteSuccess: (response, isSuccess) => ({
    type: Types.POST_PARAMETRIZACAO_CONTRATANTE_SUCCESS,
    payload: { response, isSuccess },
  }),
  postParametrizacaoContratanteError: (unsuccessResponse, error) => ({
    type: Types.POST_PARAMETRIZACAO_CONTRATANTE_ERROR,
    payload: { unsuccessResponse, error },
  }),
  getParametrizacaoUsuarioRequest: (params) => ({
    type: Types.GET_PARAMETRIZACAO_USUARIO_REQUEST,
    payload: { params },
  }),
  getParametrizacaoUsuarioSuccess: (response, isSuccess) => ({
    type: Types.GET_PARAMETRIZACAO_USUARIO_SUCCESS,
    payload: { response, isSuccess },
  }),
  getParametrizacaoUsuarioError: (unsuccessResponse, error) => ({
    type: Types.GET_PARAMETRIZACAO_USUARIO_ERROR,
    payload: { unsuccessResponse, error },
  }),
  getContratantesUsuarioRequest: (params) => ({
    type: Types.GET_CONTRATANTES_USUARIO_REQUEST,
    payload: { params },
  }),
  getContratantesUsuarioSuccess: (response, isSuccess) => ({
    type: Types.GET_CONTRATANTES_USUARIO_SUCCESS,
    payload: { response, isSuccess },
  }),
  getContratantesUsuarioError: (unsuccessResponse, error) => ({
    type: Types.GET_CONTRATANTES_USUARIO_ERROR,
    payload: { unsuccessResponse, error },
  }),
  getParametrizacaoCardsRequest: (params, cards) => ({
    type: Types.GET_PARAMETRIZACAO_CARDS_REQUEST,
    payload: { params, cards },
  }),
  getParametrizacaoCardsSuccess: (response, isSuccess) => ({
    type: Types.GET_PARAMETRIZACAO_CARDS_SUCCESS,
    payload: { response, isSuccess },
  }),
  getParametrizacaoCardsError: (unsuccessResponse, error) => ({
    type: Types.GET_PARAMETRIZACAO_CARDS_ERROR,
    payload: { unsuccessResponse, error },
  }),
  postParametrizacaoUsuarioRequest: (idUsuario, cards) => ({
    type: Types.POST_PARAMETRIZACAO_USUARIO_REQUEST,
    payload: { idUsuario, cards },
  }),
  postParametrizacaoUsuarioSuccess: (
    response,
    isSuccess,
    hasValidationErros,
    errors
  ) => ({
    type: Types.POST_PARAMETRIZACAO_USUARIO_SUCCESS,
    payload: { response, isSuccess, hasValidationErros, errors },
  }),
  postParametrizacaoUsuarioError: (unsuccessResponse, error) => ({
    type: Types.POST_PARAMETRIZACAO_USUARIO_ERROR,
    payload: { unsuccessResponse, error },
  }),
  putParametrizacaoUsuarioRequest: (idUsuario, cards) => ({
    type: Types.PUT_PARAMETRIZACAO_USUARIO_REQUEST,
    payload: { idUsuario, cards },
  }),
  putParametrizacaoUsuarioSuccess: (
    response,
    isSuccess,
    hasValidationErros,
    errors
  ) => ({
    type: Types.PUT_PARAMETRIZACAO_USUARIO_SUCCESS,
    payload: { response, isSuccess, hasValidationErros, errors },
  }),
  putParametrizacaoUsuarioError: (unsuccessResponse, error) => ({
    type: Types.PUT_PARAMETRIZACAO_USUARIO_ERROR,
    payload: { unsuccessResponse, error },
  }),
  getParametrizacaoNodeRequest: (idUsuario, params, node) => ({
    type: Types.GET_PARAMETRIZACAO_NODE_REQUEST,
    payload: { idUsuario, params, node },
  }),
  getParametrizacaoNodeSuccess: (response, isSuccess) => ({
    type: Types.GET_PARAMETRIZACAO_NODE_SUCCESS,
    payload: { response, isSuccess },
  }),
  getParametrizacaoNodeError: (unsuccessResponse, error) => ({
    type: Types.GET_PARAMETRIZACAO_NODE_ERROR,
    payload: { unsuccessResponse, error },
  }),
  parametrizacaoNodeRenew: () => ({
    type: Types.PARAMETRIZACAO_USUARIO_RENEW,
  }),
  postAtualizarSessaoLegadoRequest: (token) => ({
    type: Types.POST_ATUALIZAR_SESSAO_LEGADO_REQUEST,
    payload: { token },
  }),
  postAtualizarSessaoLegadoSuccess: (response, isSuccess) => ({
    type: Types.POST_ATUALIZAR_SESSAO_LEGADO_SUCCESS,
    payload: { response, isSuccess },
  }),
  postAtualizarSessaoLegadoError: (unsuccessResponse, error) => ({
    type: Types.POST_ATUALIZAR_SESSAO_LEGADO_ERROR,
    payload: { unsuccessResponse, error },
  }),
  getParametrizacaoCardsCompletoRequest: (
    idUsuario,
    idCard,
    idParametrizacao
  ) => ({
    type: Types.GET_PARAMETRIZACAO_CARD_COMPLETO_REQUEST,
    payload: { idUsuario, idCard, idParametrizacao },
  }),
  getParametrizacaoCardsCompletoSuccess: (response, isSuccess) => ({
    type: Types.GET_PARAMETRIZACAO_CARD_COMPLETO_SUCCESS,
    payload: { response, isSuccess },
  }),
  getParametrizacaoCardsCompletoError: (error) => ({
    type: Types.GET_PARAMETRIZACAO_CARD_COMPLETO_ERROR,
    payload: { error },
  }),
  patchParametrizacaoInativarRequest: (
    idUsuario,
    idCard,
    idParametrizacao
  ) => ({
    type: Types.PATCH_PARAMETRIZACAO_INATIVAR_REQUEST,
    payload: { idUsuario, idCard, idParametrizacao },
  }),
  patchParametrizacaoAdmInativarRequest: (idUsuario) => ({
    type: Types.PATCH_PARAMETRIZACAO_ADM_INATIVAR_REQUEST,
    payload: { idUsuario },
  }),
  patchParametrizacaoInativarSuccess: (response, isSuccess) => ({
    type: Types.PATCH_PARAMETRIZACAO_INATIVAR_SUCCESS,
    payload: { response, isSuccess },
  }),
  patchParametrizacaoInativarError: (error) => ({
    type: Types.PATCH_PARAMETRIZACAO_INATIVAR_ERROR,
    payload: { error },
  }),
  saveParametrizacaoCardsRequest: (
    idUsuario,
    postCards,
    putCards,
    isSaveAll
  ) => ({
    type: Types.SAVE_PARAMETRIZACAO_CARDS_REQUEST,
    payload: { idUsuario, postCards, putCards, isSaveAll },
  }),
  saveParametrizacaoCardsSuccess: (
    response,
    isSuccess,
    hasValidationErrors,
    errors
  ) => ({
    type: Types.SAVE_PARAMETRIZACAO_CARDS_SUCCESS,
    payload: { response, isSuccess, hasValidationErrors, errors },
  }),
  saveParametrizacaoCardsError: (error) => ({
    type: Types.SAVE_PARAMETRIZACAO_CARDS_ERROR,
    payload: { error },
  }),
  getAndBuildParametrizacaoCardsRequest: (params) => ({
    type: Types.GET_AND_BUILD_PARAMETRIZACAO_CARDS_REQUEST,
    payload: { params },
  }),
  getAndBuildParametrizacaoCardsSuccess: (response, isSuccess) => ({
    type: Types.GET_AND_BUILD_PARAMETRIZACAO_CARDS_SUCCESS,
    payload: { response, isSuccess },
  }),
  getAndBuildParametrizacaoCardsError: (unsuccessResponse, error) => ({
    type: Types.GET_AND_BUILD_PARAMETRIZACAO_CARDS_ERROR,
    payload: { unsuccessResponse, error },
  }),
  getUsuarioEspelhoRequest: (params) => ({
    type: Types.GET_USUARIOS_ESPELHO_REQUEST,
    payload: { params },
  }),
  patchAtualizarTipoPerfilRequest: (idUsuario, newRoles) => ({
    type: Types.PATCH_ATUALIZAR_TIPO_PERFIL_REQUEST,
    payload: { idUsuario, newRoles },
  }),
  postClonarUsuarioEspelhoRequest: (idUsuario, idUsuarioEspelho) => ({
    type: Types.POST_CLONAR_USUARIO_ESPELHO_REQUEST,
    payload: { idUsuario, idUsuarioEspelho },
  }),
  usuarioEspelhoSet: (usuarioEspelho) => ({
    type: Types.USUARIO_ESPELHO_SET,
    payload: { usuarioEspelho },
  }),
  usuarioEspelhoRenew: () => ({
    type: Types.USUARIO_ESPELHO_RENEW,
  }),

  success: (response) => ({
    type: Types.SUCCESS,
    payload: { response },
  }),
  error: (error) => ({
    type: Types.ERROR,
    payload: { error },
  }),
  renew: () => ({ type: Types.RENEW, payload: {} }),
};
